import axios from 'axios';

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/' : process.env.VUE_APP_API_BASE || '/api',
  timeout: 10000
});

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

export default request;
